/**
 * External dependencies
 */
import React from "react";
import { Box, Text } from "@towersystems/towersystems-design-system";
import { noop } from "lodash";

/**
 * Internal dependencies
 */
import FormCombobox from "components/forms/form-combobox";

/**
 * Style dependencies
 */
import "./styles.scss";

const Filter = ({ label, name, values, onChange = noop }) => {
  const handleOnChange = (values) => {
    onChange({ values, name });
  };

  return (
    <Box>
      <Box display="flex" alignItems="center" justifyContent="spaceBetween">
        <Text weight="medium" size="small">
          {label}:
        </Text>
      </Box>
      <Box>
        <FormCombobox
          className="dashboard__filter"
          onChange={handleOnChange}
          values={values}
          open={false}
        />
      </Box>
    </Box>
  );
};

export default Filter;
